import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { AuthProvider } from "./context/AuthContext";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Routes from "./routes";
import { PrescriptionProvider } from "./context/PrescriptionContext";
import { ThemeProvider } from "./context/ThemeContext";
import { SidebarProvider } from "./context/SidebarContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <SidebarProvider>
          <PrescriptionProvider>
            <Routes />
          </PrescriptionProvider>
        </SidebarProvider>
      </AuthProvider>
    </ThemeProvider>
    <ToastContainer position="bottom-right" style={{ zIndex: 9999999999 }} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Registra o service worker para PWA (apenas em produção)
serviceWorkerRegistration.register({
  onSuccess: () => console.log("Easyfit PWA: pronto para uso offline."),
  onUpdate: (registration) => {
    if (registration.waiting) {
      if (globalThis.confirm("Nova versão disponível! Deseja atualizar?")) {
        registration.waiting.postMessage({ type: "SKIP_WAITING" });
      }
    }
  },
});
